var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyImgLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 180,
    viewBox: "0 0 175 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1045_471)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 90,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.3553,
    cy: 16.9808,
    r: 8.98026,
    fill: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4321 52.6412C63.1487 51.6428 64.6337 51.6428 65.3503 52.6412L83.7415 78.2632C84.5944 79.4515 83.7451 81.1066 82.2824 81.1066H45.5C44.0373 81.1066 43.188 79.4515 44.0409 78.2632L62.4321 52.6412Z",
    fill: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9226 36.3712C98.6393 35.3744 100.123 35.3744 100.839 36.3712L130.955 78.2622C131.81 79.4504 130.961 81.1067 129.497 81.1067H69.2647C67.8013 81.1067 66.9522 79.4504 67.8064 78.2622L97.9226 36.3712Z",
    fill: "#DBDCDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 90,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImgLong);
export default __webpack_public_path__ + "static/media/emptyImgLong.d6f7bf1b855f5f75f169043e9cf9fd02.svg";
export { ForwardRef as ReactComponent };